import React, { Component } from "react";
import { PageHeader, Row, Col, DatePicker, Input, notification, Spin } from "antd";
import { FileExcelOutlined, FilePdfOutlined, SaveOutlined } from "@ant-design/icons";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import { ButtonItem, SelectItem, SegmentedItem } from "../../../../Components/Items";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import SelectUsuariosItem from "../../../../Components/SelectUsuariosItem";
import SelectPlantillasEvaluacionItem from "../../../../Components/SelectPlantillasEvaluacionItem";
import {
  STYLES,
  NIVO_THEME,
  colorPorcentaje,
  HeaderReporte,
  KpiRow,
  ChartCard,
  EstadoVacio,
} from "./reporteEvaluacionProveedoresStyles";
import { exportarExcelIndicador, descargarPdfIndicadorProveedores } from "./exportEvaluacionProveedores";

const { TextArea } = Input;

const ALCANCE_OPCIONES = [
  { label: "General", value: "general" },
  { label: "Proveedor(es)", value: "proveedores" },
  { label: "Tipo de proveedor", value: "tipoProveedor" },
  { label: "Responsable", value: "responsable" },
];

const FRECUENCIA_OPCIONES = [
  { label: "Mensual", value: "mensual" },
  { label: "Trimestral", value: "trimestral" },
  { label: "Semestral", value: "semestral" },
  { label: "Anual", value: "anual" },
];

class ReporteEvaluacionProveedores extends Component {
  state = {
    anio: moment().year(),
    alcanceTipo: "general",
    proveedorIds: [],
    proveedorLabels: [],
    tipoProveedorIds: [],
    responsableIds: [],
    usuariosOpciones: [],
    frecuencias: [],
    plantillaIds: [],
    plantillaLabels: [],
    tiposProveedorOpciones: [],
    reporte: null,
    loading: false,
    granularidadNotas: "trimestre", // 'trimestre' | 'mes'
    notas: [], // [{periodoTipo, periodoIndex, texto}]
    notaTextoLocal: {}, // edición en curso antes de guardar, clave `${periodoTipo}-${periodoIndex}`
    guardandoNota: null,
  };

  componentDidMount() {
    this.cargarTiposProveedor();
    this.cargarUsuarios();
    this.cargarReporte();
    this.cargarNotas();
  }

  cargarTiposProveedor = () => {
    axios
      .post(
        "tiposDeProveedores/selectTodosTiposDeProveedores",
        { empresaId: this.props.empresaId, valor: 1 },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ tiposProveedorOpciones: res.data.map((t) => ({ label: t.nombre, value: t._id })) });
        }
      })
      .catch(() => notification.error({ message: "Error al cargar los tipos de proveedor." }));
  };

  // Para mostrar nombres reales en "Filtros aplicados"
  cargarUsuarios = () => {
    axios
      .post("usuarios/selectUsuariosEmpresa", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ usuariosOpciones: res.data });
      })
      .catch(() => {});
  };

  construirAlcance = () => {
    const { alcanceTipo, proveedorIds, tipoProveedorIds, responsableIds } = this.state;
    if (alcanceTipo === "proveedores") return { tipo: "proveedores", proveedorIds };
    if (alcanceTipo === "tipoProveedor") return { tipo: "tipoProveedor", tipoProveedorIds };
    if (alcanceTipo === "responsable") return { tipo: "responsable", responsableIds };
    return { tipo: "general" };
  };

  cargarReporte = () => {
    this.setState({ loading: true });
    axios
      .post(
        "reporteEvaluacionProveedores/obtenerReporteAnual",
        {
          empresaId: this.props.empresaId,
          anio: this.state.anio,
          alcance: this.construirAlcance(),
          frecuencias: this.state.frecuencias,
          plantillaIds: this.state.plantillaIds,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ reporte: res.data });
        } else {
          notification.error({ message: res.data.message || "Error al cargar el reporte." });
        }
      })
      .catch(() => notification.error({ message: "Error de conexión al cargar el reporte." }))
      .finally(() => this.setState({ loading: false }));
  };

  cargarNotas = () => {
    axios
      .post(
        "reporteEvaluacionProveedores/obtenerNotas",
        { empresaId: this.props.empresaId, anio: this.state.anio },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) this.setState({ notas: res.data.notas });
      })
      .catch(() => notification.error({ message: "Error al cargar las notas." }));
  };

  guardarNota = (periodoTipo, periodoIndex) => {
    const clave = `${periodoTipo}-${periodoIndex}`;
    const texto = this.state.notaTextoLocal[clave] ?? this.obtenerTextoNota(periodoTipo, periodoIndex);
    this.setState({ guardandoNota: clave });
    axios
      .post(
        "reporteEvaluacionProveedores/guardarNota",
        {
          empresaId: this.props.empresaId,
          anio: this.state.anio,
          periodoTipo,
          periodoIndex,
          texto,
          usuarioId: this.props.usuarioId,
        },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.cargarNotas();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al guardar la nota." }))
      .finally(() => this.setState({ guardandoNota: null }));
  };

  obtenerTextoNota = (periodoTipo, periodoIndex) => {
    const nota = this.state.notas.find((n) => n.periodoTipo === periodoTipo && n.periodoIndex === periodoIndex);
    return nota?.texto || "";
  };

  // Etiqueta compacta para nombres de archivo al exportar
  alcanceLabel = () => {
    const { alcanceTipo, proveedorIds, tipoProveedorIds, responsableIds, frecuencias } = this.state;
    let base = "General";
    if (alcanceTipo === "proveedores") base = `Proveedores(${proveedorIds.length})`;
    else if (alcanceTipo === "tipoProveedor") base = `TipoProveedor(${tipoProveedorIds.length})`;
    else if (alcanceTipo === "responsable") base = `Responsable(${responsableIds.length})`;
    if (frecuencias?.length) base += `-Frecuencia(${frecuencias.length})`;
    return base;
  };

  // Descripción legible de cada filtro activo, para pantalla y banner del PDF/Excel
  descripcionFiltros = () => {
    const { alcanceTipo, proveedorLabels, tipoProveedorIds, tiposProveedorOpciones, responsableIds, usuariosOpciones, frecuencias, plantillaLabels } = this.state;
    const partes = [];

    if (alcanceTipo === "proveedores" && proveedorLabels.length) {
      partes.push(`Proveedor(es): ${proveedorLabels.join(", ")}`);
    } else if (alcanceTipo === "tipoProveedor" && tipoProveedorIds.length) {
      const labels = tiposProveedorOpciones.filter((o) => tipoProveedorIds.includes(o.value)).map((o) => o.label);
      if (labels.length) partes.push(`Tipo de proveedor: ${labels.join(", ")}`);
    } else if (alcanceTipo === "responsable" && responsableIds.length) {
      const labels = usuariosOpciones
        .filter((u) => responsableIds.includes(u._id))
        .map((u) => `${u.nombre} ${u.apellidoPaterno ?? ""}`.trim());
      if (labels.length) partes.push(`Responsable(s): ${labels.join(", ")}`);
    }

    if (plantillaLabels?.length) partes.push(`Plantilla: ${plantillaLabels.join(", ")}`);

    if (frecuencias?.length) {
      const labels = FRECUENCIA_OPCIONES.filter((o) => frecuencias.includes(o.value)).map((o) => o.label);
      partes.push(`Frecuencia: ${labels.join(", ")}`);
    }

    return partes;
  };

  // Nombre de la plantilla si hay una sola filtrada, si no un título genérico
  tituloIndicador = () => {
    const { plantillaLabels } = this.state;
    if (plantillaLabels?.length === 1) {
      return plantillaLabels[0].replace(/\s*\(v\d+.*\)$/, "");
    }
    return "Indicador General de Evaluación de Proveedores";
  };

  exportarExcel = () => {
    const { reporte } = this.state;
    if (!reporte) return;
    exportarExcelIndicador({
      anio: this.state.anio,
      titulo: this.tituloIndicador(),
      alcanceLabel: this.alcanceLabel(),
      filtros: this.descripcionFiltros(),
      objetivoMensual: reporte.objetivoMensual,
      meses: reporte.meses,
      trimestres: reporte.trimestres,
      acumuladoAnual: reporte.acumuladoAnual,
      notas: this.notasConEtiqueta(),
    });
  };

  exportarPdf = () => {
    const { reporte } = this.state;
    if (!reporte) return;
    descargarPdfIndicadorProveedores({
      empresa: reporte.empresa,
      anio: this.state.anio,
      titulo: this.tituloIndicador(),
      alcanceLabel: this.alcanceLabel(),
      filtros: this.descripcionFiltros(),
      objetivoMensual: reporte.objetivoMensual,
      meses: reporte.meses,
      trimestres: reporte.trimestres,
      acumuladoAnual: reporte.acumuladoAnual,
      notas: this.notasConEtiqueta(),
    });
  };

  notasConEtiqueta = () => {
    const { reporte, notas } = this.state;
    if (!reporte) return [];
    return notas
      .filter((n) => n.texto)
      .map((n) => ({
        ...n,
        etiqueta:
          n.periodoTipo === "mes"
            ? reporte.meses.find((m) => m.mes === n.periodoIndex)?.etiqueta || n.periodoIndex
            : `T${n.periodoIndex}`,
      }));
  };

  render() {
    const { reporte, loading } = this.state;
    const objetivo = reporte?.objetivoMensual ?? 73;

    return (
      <div style={{ padding: "0 20px 40px" }}>
        <style>{STYLES}</style>
        <PageHeader
          title="Indicador de Evaluación de Proveedores"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 15 }}
          onBack={() => this.props.history.goBack()}
        />

        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            padding: 20,
          }}
        >
        <HeaderReporte
          eyebrow="Sistema de Gestión de la Calidad"
          titulo={this.tituloIndicador()}
          subtitulo={`Año ${this.state.anio}`}
        />

        {this.descripcionFiltros().length > 0 && (
          <div
            style={{
              background: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              padding: "8px 14px",
              marginBottom: 16,
              fontSize: 12.5,
              color: "#475569",
            }}
          >
            <b>Filtros aplicados:</b> {this.descripcionFiltros().join("  ·  ")}
          </div>
        )}

        <div className="evp-filtros">
          <Row gutter={[12, 12]} align="middle">
            <Col>
              <DatePicker
                picker="year"
                value={moment().year(this.state.anio)}
                allowClear={false}
                onChange={(val) => this.setState({ anio: val.year() }, this.cargarReporte)}
              />
            </Col>
            <Col>
              <SegmentedItem
                options={ALCANCE_OPCIONES}
                value={this.state.alcanceTipo}
                onChange={(alcanceTipo) => this.setState({ alcanceTipo }, this.cargarReporte)}
              />
            </Col>
            {this.state.alcanceTipo === "proveedores" && (
              <Col style={{ minWidth: 260 }}>
                <SelectProveedoresItem
                  mode="multiple"
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  placeholder="Selecciona uno o varios proveedores"
                  value={this.state.proveedorIds}
                  onChange={(proveedorIds, proveedores) =>
                    this.setState(
                      {
                        proveedorIds: proveedorIds || [],
                        proveedorLabels: (proveedores || []).map((p) => p.stringBuscar || p.nombre),
                      },
                      this.cargarReporte,
                    )
                  }
                  style={{ minWidth: 260 }}
                />
              </Col>
            )}
            {this.state.alcanceTipo === "tipoProveedor" && (
              <Col style={{ minWidth: 260 }}>
                <SelectItem
                  mode="multiple"
                  placeholder="Selecciona uno o varios tipos"
                  options={this.state.tiposProveedorOpciones}
                  value={this.state.tipoProveedorIds}
                  onChange={(tipoProveedorIds) => this.setState({ tipoProveedorIds: tipoProveedorIds || [] }, this.cargarReporte)}
                  style={{ minWidth: 260 }}
                />
              </Col>
            )}
            {this.state.alcanceTipo === "responsable" && (
              <Col style={{ minWidth: 260 }}>
                <SelectUsuariosItem
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  placeholder="Selecciona uno o varios responsables"
                  value={this.state.responsableIds}
                  onChange={(responsableIds) => this.setState({ responsableIds: responsableIds || [] }, this.cargarReporte)}
                  width={260}
                />
              </Col>
            )}
            <Col style={{ minWidth: 260 }}>
              <SelectPlantillasEvaluacionItem
                mode="multiple"
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                placeholder="Plantilla (todas)"
                value={this.state.plantillaIds}
                onChange={(plantillaIds, plantillas) =>
                  this.setState(
                    {
                      plantillaIds: plantillaIds || [],
                      plantillaLabels: (plantillas || []).map((p) => p.stringBuscar || p.nombre),
                    },
                    this.cargarReporte,
                  )
                }
                style={{ minWidth: 260 }}
              />
            </Col>
            <Col style={{ minWidth: 220 }}>
              <SelectItem
                mode="multiple"
                placeholder="Frecuencia (todas)"
                options={FRECUENCIA_OPCIONES}
                value={this.state.frecuencias}
                onChange={(frecuencias) => this.setState({ frecuencias: frecuencias || [] }, this.cargarReporte)}
                style={{ minWidth: 220 }}
              />
            </Col>
            <Col flex="auto" />
            <Col>
              <ButtonItem verde icon={<FileExcelOutlined />} disabled={!reporte} onClick={this.exportarExcel}>
                Excel
              </ButtonItem>
            </Col>
            <Col>
              <ButtonItem rojo icon={<FilePdfOutlined />} disabled={!reporte} onClick={this.exportarPdf}>
                PDF
              </ButtonItem>
            </Col>
          </Row>
        </div>

        <Spin spinning={loading}>
          {!reporte ? (
            <EstadoVacio titulo="Cargando indicador…" texto="Un momento por favor." />
          ) : (
            <>
              <KpiRow
                items={[
                  { key: "objetivo", label: "Objetivo mensual", value: `${objetivo}%`, color: "#7c3aed" },
                  {
                    key: "acumulado",
                    label: "Acumulado anual",
                    value: reporte.acumuladoAnual.promedio != null ? `${reporte.acumuladoAnual.promedio}%` : "s/d",
                    color: colorPorcentaje(reporte.acumuladoAnual.promedio),
                    hint: `vs objetivo ${objetivo}%`,
                  },
                  {
                    key: "evaluaciones",
                    label: "Evaluaciones consideradas",
                    value: reporte.acumuladoAnual.evaluacionesContadas,
                    color: "#0ea5e9",
                  },
                ]}
              />

              <ChartCard label="Gráfica" titulo="Indicador mensual vs objetivo" altura={320}>
                <ResponsiveBar
                  data={reporte.meses.map((m) => ({ mes: m.etiqueta, promedio: m.promedio }))}
                  keys={["promedio"]}
                  indexBy="mes"
                  margin={{ top: 20, right: 20, bottom: 30, left: 40 }}
                  colors={(d) => (d.data.promedio == null ? "#e2e8f0" : d.data.promedio >= objetivo ? "#10b981" : "#ef4444")}
                  theme={NIVO_THEME}
                  valueScale={{ type: "linear", min: 0, max: 100 }}
                  axisLeft={{ tickValues: [0, 25, 50, 75, 100], format: (v) => `${v}%` }}
                  markers={[
                    {
                      axis: "y",
                      value: objetivo,
                      lineStyle: { stroke: "#7c3aed", strokeWidth: 2, strokeDasharray: "6 4" },
                      legend: `Objetivo: ${objetivo}%`,
                      legendPosition: "top-right",
                      textStyle: { fill: "#7c3aed", fontSize: 11, fontWeight: 600 },
                    },
                  ]}
                  enableLabel={false}
                  borderRadius={3}
                  tooltip={({ data }) => (
                    <div style={{ padding: 8, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12 }}>
                      <b>{data.mes}</b>: {data.promedio != null ? `${data.promedio}%` : "sin evaluaciones"}
                    </div>
                  )}
                />
              </ChartCard>

              <div className="evp-card">
                <div className="evp-card-label">Detalle</div>
                <h2 className="evp-card-title">Mensual</h2>
                <div className="evp-card-accent" />
                <div style={{ overflowX: "auto" }}>
                  <table className="evp-tabla">
                    <thead>
                      <tr>
                        <th></th>
                        {reporte.meses.map((m) => (
                          <th key={m.mes}>{m.etiqueta}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>Objetivo</b></td>
                        {reporte.meses.map((m) => (
                          <td key={m.mes}>{objetivo}%</td>
                        ))}
                      </tr>
                      <tr>
                        <td><b>Indicador</b></td>
                        {reporte.meses.map((m) => (
                          <td key={m.mes} className={m.promedio == null ? "evp-sindatos" : ""} style={{ color: colorPorcentaje(m.promedio), fontWeight: 700 }}>
                            {m.promedio != null ? `${m.promedio}%` : "—"}
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td><b>Evaluaciones</b></td>
                        {reporte.meses.map((m) => (
                          <td key={m.mes}>{m.evaluacionesContadas}</td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="evp-card">
                <div className="evp-card-label">Detalle</div>
                <h2 className="evp-card-title">Trimestral y acumulado</h2>
                <div className="evp-card-accent" />
                <table className="evp-tabla">
                  <thead>
                    <tr>
                      <th></th>
                      {reporte.trimestres.map((t) => (
                        <th key={t.trimestre}>{t.etiqueta}</th>
                      ))}
                      <th>Acumulado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>Objetivo</b></td>
                      {reporte.trimestres.map((t) => (
                        <td key={t.trimestre}>{objetivo}%</td>
                      ))}
                      <td>{objetivo}%</td>
                    </tr>
                    <tr>
                      <td><b>Indicador</b></td>
                      {reporte.trimestres.map((t) => (
                        <td key={t.trimestre} className={t.promedio == null ? "evp-sindatos" : ""} style={{ color: colorPorcentaje(t.promedio), fontWeight: 700 }}>
                          {t.promedio != null ? `${t.promedio}%` : "—"}
                        </td>
                      ))}
                      <td style={{ color: colorPorcentaje(reporte.acumuladoAnual.promedio), fontWeight: 700 }}>
                        {reporte.acumuladoAnual.promedio != null ? `${reporte.acumuladoAnual.promedio}%` : "—"}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Evaluaciones</b></td>
                      {reporte.trimestres.map((t) => (
                        <td key={t.trimestre}>{t.evaluacionesContadas}</td>
                      ))}
                      <td>{reporte.acumuladoAnual.evaluacionesContadas}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="evp-card">
                <div className="evp-card-label">Seguimiento</div>
                <h2 className="evp-card-title">Notas / Acciones correctivas</h2>
                <div className="evp-card-accent" />
                <div style={{ marginBottom: 10 }}>
                  <SegmentedItem
                    options={[
                      { label: "Por trimestre", value: "trimestre" },
                      { label: "Por mes", value: "mes" },
                    ]}
                    value={this.state.granularidadNotas}
                    onChange={(granularidadNotas) => this.setState({ granularidadNotas })}
                  />
                </div>
                {(this.state.granularidadNotas === "trimestre" ? reporte.trimestres : reporte.meses).map((periodo) => {
                  const periodoTipo = this.state.granularidadNotas;
                  const periodoIndex = periodoTipo === "trimestre" ? periodo.trimestre : periodo.mes;
                  const clave = `${periodoTipo}-${periodoIndex}`;
                  const valorActual = this.state.notaTextoLocal[clave] ?? this.obtenerTextoNota(periodoTipo, periodoIndex);
                  return (
                    <Row key={clave} gutter={12} align="top" style={{ marginBottom: 10 }}>
                      <Col flex="90px" style={{ paddingTop: 6, fontWeight: 600, color: "#64748b" }}>
                        {periodo.etiqueta}
                      </Col>
                      <Col flex="auto">
                        <TextArea
                          rows={2}
                          placeholder="Sin notas para este periodo."
                          value={valorActual}
                          onChange={(e) =>
                            this.setState({
                              notaTextoLocal: { ...this.state.notaTextoLocal, [clave]: e.target.value },
                            })
                          }
                        />
                      </Col>
                      <Col flex="100px" style={{ paddingTop: 4 }}>
                        <ButtonItem
                          azul
                          size="small"
                          icon={<SaveOutlined />}
                          loading={this.state.guardandoNota === clave}
                          onClick={() => this.guardarNota(periodoTipo, periodoIndex)}
                        >
                          Guardar
                        </ButtonItem>
                      </Col>
                    </Row>
                  );
                })}
              </div>
            </>
          )}
        </Spin>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.id,
});

export default connect(mapStateToProps)(ReporteEvaluacionProveedores);
